module.exports = __webpack_public_path__ + "03_long_black.2752a636.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/03_long_black.png
// module id = ridm
// module chunks = 0